import Head from 'next/head'
import React from 'react'

const ForeverTiles = () => {
  return (
    <>
     <Head>
    <title>Scratch Free Tile(Forever Tile): Revolutionizing Durability by Orientbell</title>
<meta name="title" content='Scratch Free Tile(Forever Tile): Revolutionizing Durability by Orientbell'/>
<meta name="description" content='Scratch Free Tile(Forever Tile) by Orientbell revolutionize durability with their innovative technology, offering scratch-free and long-lasting germ-free tiles.'/>
    </Head>
      <div className='cool_tiles_pages forever_tiles_page'>
        <div className='container'>
            <h1>Scratch Free Tile(Forever Tile)</h1>
            <div className='forever_tiles_data'>
                <strong>Patent Application No. : Scratch Free Tile(Forever Tile) : 685/CHE/2011</strong>
                <p>Scratch Free Tile(Forever Tile) come with a surface that is highly abrasion, scratch and stain resistant. These tiles are rated 8 on Moh&aposs scale of hardness where diamond is on 10 and iron is on 4. So, if you try to scratch them with any knife, the knife will get scratched.</p>
                <button type="button" class="btn btn-primary">View all Scratch Free Tile(Forever Tile)</button>
            </div>
            <h4>INVENTION</h4>
            <p>The invention is a corundum based coating composition and the method of applying it on the ceramic tiles for producing tiles with extreme abrasion and scratch resistance.</p>
            <img src='/forever-invention_1.jpg' alt='Forever Invention'/>
            <strong>Concept</strong>   
            <p>How is this achieved? During the manufacturing process:</p>
            <ul>
                <li>First engobe coating is applied.</li>
                <li>Third corundum paste base coating is applied.</li>
                <li>Second corundum base glaze coating is applied.</li>
                <li>Fourth corundum base over coating is applied.</li>
            </ul>
            <strong>Features</strong> 
            <ul>
                <li>These tiles have self cleaning property as tested by Queens IPS Lab, UK.</li>
                <li>Very high scratch resistance.</li>
                <li>Very low water absorption.</li>
                <li>Rated 8 on Moh’s scale of hardness where diamond is rated 10.</li>
                <li>Impact resistance.</li>
            </ul>
            <strong>Where to Use?</strong> 
            <ul>
                <li>Inside homes, specially those with children</li>
                <li>Bedroom, kitchen</li>
                <li>Shopping malls.</li>
                <li>Driveways, pathways</li>
                <li>High traffic areas.</li>
                <li>Commercial spaces.</li>
            </ul>
        </div>
      </div>
    </>
  )
}

export default ForeverTiles
